import React from 'react';
import { SchemaBuilderProps } from './formBuilderSchema';
import { Divider, HStack, Stack } from '@chakra-ui/core';
import InputPreview from './InputPreview';
import FormElementTextBuilder from './FormElementTextBuilder';
import LabelSchemaBuilder from './LabelSchemaBuilder';
import { useTranslation } from 'react-i18next';
// import InputMinMaxSelector from './InputMinMaxSelector';

export default function PhoneSchemaBuilder({ ...props }: SchemaBuilderProps) {
  const { t } = useTranslation('hrFormTemplate');

  return (
    <Stack>
      <HStack justify="space-between">
        <LabelSchemaBuilder {...props} />
        <HStack flexShrink={0}>
          <Divider orientation="vertical" />
          {props?.labelRightRenderer}
        </HStack>
      </HStack>
      <FormElementTextBuilder {...props} placeholder={t('formBuilder.editorPlaceholder.phone')} />
      <InputPreview
        value={props?.defaultValue?.previewPlaceholders?.placeholder ?? '000-000-0000'}
        // rightContent={<InputMinMaxSelector {...props} />}
      />
    </Stack>
  );
}
